<template>
  <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
  <RouterView :key="$route.fullPath" />
</template>

<script>
import appConfig from "@/app.config";

export default {
  metaInfo: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  }
};
</script>
